module.exports = __webpack_public_path__ + "static/media/icon_top_arrow.46225bdf.svg";